import { render, staticRenderFns } from "./OutlineButton.vue?vue&type=template&id=6c55110c&scoped=true&"
var script = {}
import style0 from "./OutlineButton.vue?vue&type=style&index=0&id=6c55110c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55110c",
  null
  
)

export default component.exports